import { FC, useCallback } from "react"
import Table from "../../table"
import ListSkeleton from "../../skeletons/normal-list"
import { useFetchSubscriptionActivityStatsQuery } from "../../../../redux/queries"
import { useAppDispatch, useAppSelector } from "../../../hooks"
import {
  selectTabRange,
  updateRange
} from "../../../../redux/slices/engagements"
import {
  BBColumnDef,
  DateRange,
  EngagementsTab,
  SubscriptionActivityStat
} from "../../../../types"
import DaysFilter from "../../days-filter"

type EngagementsActivityTableProps = {
  orgId: string | undefined
  brandId: string | undefined
  loid: string | undefined
  columns: BBColumnDef<SubscriptionActivityStat>[]
}

const EngagementsActivityTable: FC<EngagementsActivityTableProps> = ({
  orgId,
  brandId,
  loid,
  columns
}) => {
  const dispatch = useAppDispatch()
  const tabKey = EngagementsTab.activity
  const range = useAppSelector(state => selectTabRange(state, tabKey))
  const handleUpdateRange = useCallback(
    (newValue: DateRange) => {
      dispatch(updateRange({ tabKey, newValue }))
    },
    [dispatch, tabKey]
  )

  // Fetch subscription activity stats
  const { data: subscriptionActivityStats, isFetching } =
    useFetchSubscriptionActivityStatsQuery(
      {
        event_range: range,
        sort_by: "num_total_dashboard_views",
        org_id: orgId,
        brand_id: brandId,
        loid
      },
      { skip: !orgId && !brandId && !loid }
    )

  return (
    <Table
      isLoading={isFetching}
      data={subscriptionActivityStats ?? []}
      columns={columns}
      viewType="table"
      searchPlaceholder="Search in activity…"
      extraHeaderElement={
        <DaysFilter range={range} handleUpdateRange={handleUpdateRange} />
      }
      extraHeaderElementClassName="w-full md:w-auto md:ml-auto"
      noSorter
      defaultSortBy="total-dashboard-views"
      defaultSortDir="desc"
      tableClassName="md:table-fixed"
      loaderSkeleton={<ListSkeleton noOfRows={10} noOfColumns={4} />}
      containColumnsSorter
      removeMobilePagination
    />
  )
}

export default EngagementsActivityTable
